import $ from 'jquery';
import '../scss/hub-main.scss';
import select2 from 'select2';
import 'select2/dist/css/select2.css';
//Hook up select2 to jQuery
select2($);

import smartWizard from 'smartwizard';
import "smartwizard/dist/css/smart_wizard_all.css";
smartWizard($)

$(document).ready(function () {

    if ($(".dashMenu").length > 0) {
        if (window.matchMedia('(max-width: 991px)').matches) {
            if ($("#footer-spacer").length) {
                $('#footer-spacer').remove();
            } else {
                $('footer').after("<div id='footer-spacer' style='height: 70px; background-color: rgb(240, 240, 240);' ></div>");
            }
        }
        $(window).resize(function () {
            if (window.matchMedia('(max-width: 991px)').matches) {
                if ($("#footer-spacer").length) {

                } else {
                    $("footer").after("<div id='footer-spacer' style='height: 70px; background-color: rgb(240, 240, 240);' ></div>");
                }
            } else if (window.matchMedia('(min-width: 992px)').matches) {
                $('#footer-spacer').remove();
            }
        });
    }

    $("#social_tags").select2({
        multiple: true,
        allowClear: true,
        placeholder: "Nessuna selezione",
    });

    /*********************************
     * Ajax Requests for download
     ********************************/
    var urlParams = new URLSearchParams(window.location.search);
    var filters = {};
    var renderData = null;
    var renderSelector = "#downloads-render";


    var renderConfig = [
        {
            type: "downloads",
            selector: "#downloads-render",
            endpoint: "/digitalhub/results/",
            btnLoadMore: "#loadMoreDownloads"
        },
        {
            type: "photos",
            selector: "#photos-render",
            endpoint: "/digitalhub/results/photos/",
            btnLoadMore: "#loadMorePhotos"
        },
        {
            type: "videos",
            selector: "#videos-render",
            endpoint: "/digitalhub/results/videos/",
            btnLoadMore: "#loadMoreVideos"
        },
        {
            type: "posts",
            selector: "#posts-render",
            endpoint: "/digitalhub/results/posts/",
            btnLoadMore: "#loadMorePosts"
        },
        {
            //serve per far funzionare i preferiti delle categorie
            type: "downloads-cat",
            selector: "#downloads-render",
            // endpoint: "/digitalhub/results/"
        },
        {
            //serve per far funzionare i preferiti delle categorie
            type: "photos-cat",
            selector: "#photos-render",
            // endpoint: "/digitalhub/results/photos/"
        },
        {
            //serve per far funzionare i preferiti delle categorie
            type: "videos-cat",
            selector: "#videos-render",
            // endpoint: "/digitalhub/results/videos/"
        },
        {
            type: "search",
            selector: "#search-render",
            endpoint: "/digitalhub/results/search/"
        },
        {
            type: "profilo",
            selector: "#profilo-render",
            endpoint: "/digitalhub/results/active-notifications/"
        }
    ];


    let currentPage = 1;
    let limit = 12;

    $.each(renderConfig, function (index, value) {
        if ($(value.selector).length > 0 && value.endpoint ) {
            renderData = $(value.selector).data("result");
            filters.search = urlParams.has('keyword')?urlParams.get('keyword'):"";
            filters.category = urlParams.get('category')?urlParams.get('category'):"";
            if (value.type === "search") {
                searchStore(filters.search);
            }
            quickRender(filters, null, value.selector);
        }

        //If category has been provided then load that category
        //senza questo IF lancia 9 volte quickRender quindi 9 chiamate
        // perchè il renderConfig ha 9 elementi... e in qualche modo viene eseguito 9 volte
        // if ($(value.selector).length > 0 && value.endpoint ) {
        //     if (urlParams.has('category')) {
        //         filters.category = urlParams.get('category');
        //         quickRender(filters, null, value.selector);
        //     }
        // }

        $(value.selector).on("click", '.download_category_box', function () {
            filters.category = $(this).data("id");
            quickRender(filters, null, value.selector);
        });

        //
        //
        // //DOWNLOAD NOTIFICATIONS
        // var confirmSubscribeModal = null;
        // if (document.querySelector('#confirmSubscribe'+value.type)) {
        //     confirmSubscribeModal = new bootstrap.Modal(document.querySelector('#confirmSubscribe'+value.type));
        //     $(renderSelector).on("click", '.category_notification', function () {
        //         let item = $(this);
        //
        //         let confirmSubscribeEl = $("#confirmSubscribe"+value.type);
        //         if (item.hasClass("active")) {
        //             confirmSubscribeEl.find(".modal-title").text(item.data('title-inactive') + ' '+ item.data('category').title + "?");
        //             confirmSubscribeEl.find(".modal-subtitle").text(item.data('subtitle-inactive'));
        //         } else {
        //             confirmSubscribeEl.find(".modal-title").text(item.data('title-active') + ' '+ item.data('category').title + "?");
        //             confirmSubscribeEl.find(".modal-subtitle").text(item.data('subtitle-active'));
        //         }
        //
        //         confirmSubscribeModal.show();
        //         $(".download-categories-list .category_notification").removeClass("action-active");
        //         $(this).addClass("action-active");
        //     });
        // }

        if (value.btnLoadMore != null) {
            $(value.selector).off("click", value.btnLoadMore).on("click", value.btnLoadMore, function () {
                currentPage++;
                quickRender(filters, null, value.selector, true);
            });
        }
    });


    function quickRender(filter = null, calendar = null, idSelector = "", append = false) {
        ajaxLoading("d-none", "d-block");
        limit = $(idSelector).data("limit") ? $(idSelector).data("limit") : limit;

        $.ajax({
            url: '/digitalhub/results/' + renderData + '?filters=' + stringfy(filter)+'&calendar='+(calendar != null ? calendar : 'null')+'&page='+currentPage+'&limit='+limit,
            success: function (profiles) {
                ajaxLoading("d-block", "d-none");
                $(idSelector).html(profiles);
            },
            error: function (xhr) {
                ajaxLoading("d-block", "d-none");
                if (xhr.status === 403) {
                    $(idSelector).html('<div class="col-12 pt-4"><h4>Accesso non consentito</h4><p>Non hai i permessi per visualizzare questa categoria.</p></div>');
                }
            }
        });
    }

    function stringfy(obj) {
        var param = "";
        $.each(obj, function (key, value) {
            param += key + ":" + value + ";";
        });
        return param
    }

    function ajaxLoading(show, hide) {
        $(".ajax-loading").removeClass(show).addClass(hide);
    }



    //gestione notifiche del profilo
    let confirmSubscribeModalProfilo = null;
    if (document.querySelector('#confirmSubscribeprofilo')) {
        confirmSubscribeModalProfilo = new bootstrap.Modal(document.querySelector('#confirmSubscribeprofilo'));
        $("#profilo-render").on("click", '.category_notification', function () {
            let item = $(this);

            let itemType = item.data("type");
            let confirmSubscribeEl = $("#confirmSubscribeprofilo");
            confirmSubscribeEl.find(".btn-data-notification").data("type", itemType);

            if (item.hasClass("active")) {
                confirmSubscribeEl.find(".modal-title").text(item.data('title-inactive') + ' '+ item.data('category').title + "?");
                confirmSubscribeEl.find(".modal-subtitle").text(item.data('subtitle-inactive'));
            } else {
                confirmSubscribeEl.find(".modal-title").text(item.data('title-active') + ' '+ item.data('category').title + "?");
                confirmSubscribeEl.find(".modal-subtitle").text(item.data('subtitle-active'));
            }

            confirmSubscribeModalProfilo.show();
            $(".category_notification").removeClass("action-active");
            $(this).addClass("action-active");
        });
    }

    $("#confirmSubscribeprofilo .btn-data-notification").click(function () {
        let action = $(this).data("action");
        let typeElement = $(this).data("type");
        confirmSubscribeModalProfilo.hide();

        if (action === "proceed") {
            subscriptionProfilo(typeElement);
        }

        $(".download-categories-list .category_notification").removeClass("action-active");
    })


    function subscriptionProfilo(typeElement) {
        let item = $(".action-active");
        let type = '';
        let action = item.data("action");

        if (item.hasClass("active")) {
            type = 'disable'
        } else if (item.hasClass("disable")) {
            type = 'active'
        } else {
            type = 'active'
        }
        let catChildrens = item.data('category').children;
        $.ajax({
            type: "POST",
            url: '/digitalhub/results/'+typeElement+'/notification',
            data: {id: item.data("id"), trigger: type},
            success: function () {
                if (item.hasClass('found-in')) {
                    item.removeClass('found-in');
                    item.addClass('active');
                } else if (item.hasClass('active')) {
                    item.removeClass("active");
                } else {
                    item.addClass("active");
                }
            }
        });
        if (action === "hide") {
            item.parent().remove();
            var container = $(".category-notification-profile").length;
            if (container === 0) {
                let notification_title = $(".profile-notification-title").data("profile-notification");
                $(".profile-notification-title").text(notification_title);
            }
        }
        if (catChildrens && type === 'active') {
            $.each(catChildrens, function (index, value) {
                $.ajax({
                    type: "POST",
                    url: '/digitalhub/results/downloads/notification',
                    data: {id: value, trigger: 'disable'},
                });
            });
        }
    }

    //DOWNLOAD FAVOURITE
    // $(renderSelector).on("click", '.download-favorite', function () {
    //     let item = $(this);
    //     let type = item.hasClass("active") ? "disable" : "active";
    //     $.ajax({
    //         type: "POST",
    //         url: '/digitalhub/results/downloads/favourite',
    //         data: {id: item.data("id"), trigger: type},
    //         success: function (data) {
    //
    //             item.find("span").text(data.label);
    //             $(renderSelector).find(".download-item-" + item.data("id")).remove();
    //
    //             if (type === "active") {
    //                 item.addClass("active");
    //             } else {
    //                 item.removeClass("active");
    //
    //             }
    //         }
    //     });
    //     let prefcontainer = $(".preferiti-check-lenght").length;
    //     if (prefcontainer === 1) {
    //         let no_preferiti = $(".preferiti-check-title").data("nopreferiti");
    //         $(".preferiti-check-title").text(no_preferiti);
    //         $(".ordinator").css('display', 'none');
    //     }
    //
    // });
    //DOWNLOAD SORTING
    $(renderSelector).on("change", '#reorder', function () {
        filters.sort = $(this).val();
        filters.sortby = $(this).children(":selected").data("id");
        quickRender(filters);
    });
    //SEARCH DATA
    // $(".ajax-search").click(function(e){
    //     $keyword = $(".search-bar").val();
    //     if($keyword!=""){
    //         filters["search"]     = $keyword;
    //         quickRender(filters);
    //         searchStore($keyword);
    //     }
    // })

    // $('.search-bar').keyup(function (e) {
    //     if (e.keyCode === 13) {
    //         let keyword = $(this).val();
    //         if (keyword !== '') {
    //             filters.search = keyword;
    //             quickRender(filters);
    //             searchStore(keyword);
    //         }
    //     }
    // });
    //SEARCH FROM THIRD PARTY URL
    // let searchParams = new URLSearchParams(window.location.search);
    // let param = searchParams.get('keyword');
    // if (param) {
    //     setTimeout(function () {
    //         $(".search-bar").val(param);
    //         filters.search = param;
    //         quickRender(filters);
    //         searchStore(param);
    //     }, 100)
    //
    // }

    //SEARCH TRACKING PROBLEM
    function searchStore(keyword) {
        $.ajax({
            type: "POST",
            url: '/digitalhub/track/search',
            data: {keyword: keyword},
            success: function (data) {
            }
        });
    }

    //ON CLEAR RETURN ALL RESULTS
    // $(".search-bar").on('input', function () {
    //     let keyword = $(this).val();
    //     if (keyword.length <= 0) {
    //         filters.search = "";
    //         quickRender(filters);
    //     }
    // });

    /****************************
     * LOGIN/REGISTER SCRIPT
     ****************************/

    $(".frontend__show").click(function () {
        $(this).parent().find('.password').attr('type', function (index, attr) {
            return attr === 'text' ? 'password' : 'text';
        });
        $(this).toggleClass("fa-eye fa-eye-slash");
    })

    $('.btn-data-confirm-password').click(function () {
        window.alert = function alert(message) {
            $(".btn-data-confirm-password-error").show().text(message);

        }
    })
    //pop un password
    $('#registerPassword').focus(function () {
        // register-speeche-bubble
        $(".register-speeche-bubble").show();
    }).focusout(function () {
        // register-speeche-bubble
        $(".register-speeche-bubble").hide();
    });



    $(renderSelector).on("click", '.dropbtn', function () {
        $("#myDropdown").toggleClass("show");
    });

    $("body").click(function (e) {
        if (!$(e.target).hasClass("dropbtn") && !$(e.target).hasClass("date-input")) {
            let selector = $("#myDropdown");
            if (selector.hasClass("show")) {
                selector.removeClass("show")
            }
        }

    });

    /****************************
     * POPUP TICKET DETAIL
     ****************************/
    $(renderSelector).on("mouseover", '.ticket-detail', function () {
        popupRenderTicket($(this));
        $(".pop-closer").hide();
    });

    $(renderSelector).on("mouseleave", '.ticket-detail', function () {
        $(".speech-bg").hide();
        $('.download-list .active-row').removeClass("active-row");
    });

    $(renderSelector).on("click", '.ticket-detail-mobile', function () {
        popupRenderTicket($(this));
        $(".pop-closer").show();
    });

    $(renderSelector).on("click", document, function (event) {
        if (!$(event.target).closest(".ticket-detail-mobile").length) {
            $(".speech-bg").hide();
            $('.download-list .active-row').removeClass("active-row");
        }
    });


    function popupRenderTicket(item) {
        let popupHeight;
        let popupWidth;
        let speech_bg = $(".speech-bg");

        if (window.matchMedia("(max-width: 767px)").matches) {
            popupHeight = speech_bg.outerHeight() + 10;
            popupWidth = speech_bg.outerWidth() - 120;
        } else if (window.matchMedia("(max-width: 1199px)").matches) {
            popupHeight = speech_bg.outerHeight() + 100;
            popupWidth = speech_bg.outerWidth() - 120;
        } else {
            popupHeight = speech_bg.outerHeight() / 2 - 10;
            popupWidth = speech_bg.outerWidth() + 30;
        }
        let position = $(item).position();
        let top = position.top - popupHeight;
        let left = position.left - popupWidth;

        //Render Data
        let data = $(item).data("ticket");
        let lastmsg = $(item).find(".ticket-summary").html();
        let lastmsgdate = ($(item).data("lastmsgdate"));
        let msgurl = ($(item).data("msgurl"));
        let lastsender = ($(item).data("lastsender"));
        $(".box-speech a.ticket-button").attr("href", msgurl);
        $(".box-speech .title").text(data.title);
        $(".box-speech .category").text(data.category);
        $(".box-speech .lastSender").text(lastsender);
        $(".box-speech .lastMessageText").html(lastmsg);
        $(".box-speech .lastMessageDate").text("(" + lastmsgdate + ")");
        speech_bg.css("top", top).css("left", left).show();
        $('.download-list .active-row').removeClass("active-row");
        $(item).parent().parent().parent().addClass("active-row");
    }


    $(renderSelector).on("click", '.pop-closer', function () {
        $('.download-list .active-row').removeClass("active-row");
        $(".speech-bg").hide();
    });

    $(renderSelector).on("click", '.resetta', function () {
        $('.date-resetted').val('')
            .attr('type', 'text')
            .attr('type', 'date');
    });

    // TICKET CREATION MODAL
    var createTicketModal = null;
    if (document.querySelector("#createTicket")) {
        createTicketModal = new bootstrap.Modal(document.querySelector("#createTicket"));
        $(renderSelector).on("click", '.new_ticket', function () {
            createTicketModal.show();
        });
    }

    // TICKET REOPEN MODAL
    var reopenTicketModal = null;
    if (document.querySelector("#reopenTicket")) {
        reopenTicketModal = new bootstrap.Modal(document.querySelector("#reopenTicket"));
        $(renderSelector).on("click", '.ticket-button-open', function () {
            reopenTicketModal.show();
        });
    }

    // TICKET CLOSE MODAL
    var closeTicketModal = null;
    if (document.querySelector("#closeTicket")) {
        closeTicketModal = new bootstrap.Modal(document.querySelector("#closeTicket"));
        $(renderSelector).on("click", '.ticket-button-close', function () {
            closeTicketModal.show();
        });
    }

    $(".status-changer").click(function () {
        let item = $(this);
        $.ajax({
            type: "POST",
            url: '/digitalhub/results/update/ticket',
            data: {id: item.data("id"), type: item.data("type")},
            success: function (data) {
                closeTicketModal.hide();
                reopenTicketModal.hide();
                if (data.type === "success") {
                    quickRender(filters);
                }
                global.$.oc.flashMsg({
                    'text': data.msg,
                    'class': data.type,
                    'interval': 5
                })
            }

        });
    });
    // SEND MESSAGE FOR TICKET
    $(renderSelector).on("submit", '#commnetForm', function (event) {
        event.preventDefault();
        let formData = new FormData(this);

        $.ajax({
            type: "POST",
            url: '/digitalhub/results/update/comment',
            data: formData,
            success: function (data) {
                if (data.type === "success") {
                    quickRender(filters);
                }
                global.$.oc.flashMsg({
                    'text': data.msg,
                    'class': data.type,
                    'interval': 5
                })
            },
            cache: false,
            contentType: false,
            processData: false
        });
    });

    // CREATE TICKET
    $("#ticketProcess").submit(function (event) {
        event.preventDefault();
        let formData = new FormData(this);
        // ticket
        $.ajax({
            type: "POST",
            url: '/digitalhub/results/create/ticket',
            data: formData,
            success: function (data) {
                if (data.type === "success") {
                    quickRender(filters);
                    createTicketModal.hide();
                }
                global.$.oc.flashMsg({
                    'text': data.msg,
                    'class': data.type,
                    'interval': 5
                })
            },
            cache: false,
            contentType: false,
            processData: false
        });
    });

    $(renderSelector).on("change", '#categoriesFilter', function () {
        filters.category = $(this).val();
        filters.categoryby = 'category_id';
        quickRender(filters);
    });

    $(renderSelector).on("change", '#stateFilter', function () {
        filters.status = $(this).val();
        filters.statusby = "status_id";
        quickRender(filters);
    });

    $(renderSelector).on("click", '#dateFilter,#dateReset', function () {
        filters.dateFrom = $('input[name="dateFrom"]').val();
        filters.dateTo = $('input[name="dateTo"]').val();
        filters.dateby = "created_at";
        quickRender(filters);
    });

    //Popup on Dashboard for creating tickets
    $('.new_ticket').click(function () {
        createTicketModal.show();
    });

    //button to clark
    $.ajax({
        type: "GET",
        url: "/digitalhub/results/settings",
        success: function (result) {
            $('.buttonLinkToHub').attr("href", "/" + result)
        },
    });

    // Social filters
    $("#post_status").on("change", function () {
        filters.post_status = $(this).val();
        if (btnCalendar.text() === 'Elenco'){
            renderData = 'socialpostscalendar'
        } else {
            renderData = 'socialposts'
        }
        quickRender(filters);
    });

    $("#social_type").on("change", function () {
        filters.social_type = $(this).val();

        let canedareView = null

        if ($('#calendar').length != 0 ){
            canedareView = ($(calendar)[0].currentData.currentViewType);
        }
        const btnCalendar = $('#btnCalendar');
        if (btnCalendar.text() === 'Elenco'){
            renderData = 'socialpostscalendar'
        }else {
            renderData = 'socialposts'
        }


        quickRender(filters,canedareView, "#posts-render");
    });

    $("#social_tags").on("change", function () {
        filters.social_tags = $(this).val();
        quickRender(filters, null, "#posts-render");
    });

    $("#social_reorder").on("change", function () {
        filters.social_reorder = $(this).val();
        quickRender(filters);
    });

    $("#column_list").on("change", function () {
        filters.column_list = $(this).val();

        quickRender(filters, null, "#posts-render");
    });

    $("#date_start").on("change", function () {
        filters.date_start = $(this).val();
        quickRender(filters);
    });

    $("#date_end").on("change", function () {
        filters.date_end = $(this).val();
        quickRender(filters);
    });

    // $('.search-bar-social').keyup(function (e) {
    //     if (e.keyCode === 13) {
    //         let keyword = $(this).val();
    //         if (keyword !== '') {
    //             filters.search = keyword;
    //             quickRender(filters);
    //         }
    //     }
    // });


    // Ayrshare

    $("#as_connect_socials").on("click", function (e) {
        let id = $(this).data("id");
        e.preventDefault()
        e.stopPropagation()
        ajaxLoading("d-none", "d-block");
        $.ajax({
            type: "POST",
            url: '/digitalhub/socialpost/connect_socials',
            data: {id: id},
            success: function (data) {
                ajaxLoading("d-block", "d-none");
                popupWindowConnectSocial(data.url);
            }
        });
    });

    function popupWindowConnectSocial(url) {
        if (window.innerWidth > 768){
            const windowSize = {
                width: 1000,
                height: 800,
            };
            const windowLocation = {
                left:  (window.screen.availLeft + (window.screen.availWidth / 2)) - (windowSize.width / 2),
                top: (window.screen.availTop + (window.screen.availHeight / 2)) - (windowSize.height / 2),
            };
            return window.open(url, '_blank', 'width=' + windowSize.width + ', height=' + windowSize.height + ', left=' + windowLocation.left + ', top=' + windowLocation.top);
        }else {
            return window.open(url, '_blank', 'fullscreen=yes');
        }
    }

    // Function to fetch the ajax content
    function provideContentConnect(idx, stepDirection, stepPosition, selStep, callback) {
        let connectW = $('#smartwizardConnect')
        let urlBack = '';
        $('#smartwizardConnect .finish-link').hide();
        $('#smartwizardConnect .sw-btn-finish').hide();
        $.ajax({
            type: "GET",
            url: "/digitalhub/results/settings",
            success: function (result) {
                $('.sw-btn-abort').attr("href", "/" + result + '/profilo/')
                urlBack = ("/" + result + '/profilo/');
            },
        });
        // You can use stepDirection to get ajax content on the forward movement and stepPosition to identify the step position
        if (stepDirection === 'forward' ) {
            if(idx === 0){
                callback()
            }

            if(idx === 1){
                $.ajax({
                    type: "POST",
                    url: '/digitalhub/socialpost/create_user_profile',
                    data: {id: connectW.data('id')},
                    beforeSend: function( xhr ) {
                        // Show the loader
                        $('#smartwizardConnect').smartWizard("loader", "show");
                    },
                    success: function (data) {
                        if (data.type === 'success'){

                            //resize for media mobile
                            $('#smartwizardConnect .sw-btn-finish').show().on( "click", function(e) {
                                e.preventDefault()
                                popupWindowConnectSocial(data.url);
                                // redirect
                                window.location = urlBack;
                            });

                            $('#smartwizardConnect .sw-btn-next').addClass('d-none');
                            connectW.smartWizard("setState", [0], "done");
                            callback()
                        } else {
                            connectW.smartWizard("setState", [0], "error");
                            $('#smartwizardConnect #step-1 h3').text('Error: '+ data.msg);
                            connectW.smartWizard("fixHeight");
                        }
                        global.$.oc.flashMsg({
                            'text': data.msg,
                            'class': data.type,
                            'interval': 5
                        })
                        connectW.smartWizard("loader", "hide");
                    }
                });
            }
        }
    }


    // SmartWizard initialize
    $('#smartwizardConnect').smartWizard({
        theme: 'arrows',
        lang: { // Language variables for button
            next: 'Procedi',
        },
        toolbar: {
            showPreviousButton: false, // show/hide a Previous button
            extraHtml: `<a target="_blank" data-id="{{ user.id }}" href="" class="btn btn-success sw-btn-finish">Associa</a> <a class="btn btn-secondary sw-btn-abort">Annulla</a>`
        },
        anchor: {
            enableNavigation: false, // Enable/Disable anchor navigation
        },
        getContent: provideContentConnect
    });

    //Modal socialshare delete profile
    let confirmSocialUserDeleteModal = null;
    if (document.querySelector('#confirmSocialUserDelete')) {
        $('#social_redirector').removeClass('d-flex').addClass('d-none');
        confirmSocialUserDeleteModal = new bootstrap.Modal(document.querySelector('#confirmSocialUserDelete'));
        $("#as_delete_socials_user").on("click", function () {
            confirmSocialUserDeleteModal.show();
        });
    }

    $(".btn-data-social").click(function () {
        let action = $(this).data("action");
        let id = $(this).data("id");
        confirmSocialUserDeleteModal.hide();
        if (action === "proceed") {
            ajaxLoading("d-none", "d-block");
            $.ajax({
                type: "POST",
                url: '/digitalhub/socialpost/delete_user_profile',
                data: { id: id },
                success: function (data) {
                    if (data.type === 'success') {
                        ajaxLoading("d-block", "d-none");
                        $('#social_redirector').removeClass('d-none').addClass('d-flex');
                        $('#as_delete_socials_user').parent().addClass('d-none');
                        $('#as_connect_socials').parent().addClass('d-none');
                    }
                    global.$.oc.flashMsg({
                        'text': data.msg,
                        'class': data.type,
                        'interval': 5
                    })
                }
            });
        }
    })

    let consent_auto_post = $('#consent_auto_post')
    if ($('#consent_auto_post_chk').is(':checked')){
        $(consent_auto_post).val(1);
    } else {
        $(consent_auto_post).val(0);
    }
    $('#consent_auto_post_chk').change(function () {
        if ($('#consent_auto_post_chk').is(':checked')){
            $(consent_auto_post).val(1);
        } else {
            $(consent_auto_post).val(0);
        }
    })

    let notify_auto_post = $('#notify_auto_post')
    if ($('#notify_auto_post_chk').is(':checked')){
        $(notify_auto_post).val(1);
    } else {
        $(notify_auto_post).val(0);
    }
    $('#notify_auto_post_chk').change(function () {
        if ($('#notify_auto_post_chk').is(':checked')){
            $(notify_auto_post).val(1);
        } else {
            $(notify_auto_post).val(0);
        }
    })

    let notify_new_post = $('#notify_new_post')
    if ($('#notify_new_post_chk').is(':checked')){
        $(notify_new_post).val(1);
    } else {
        $(notify_new_post).val(0);
    }
    $('#notify_new_post_chk').change(function () {
        if ($('#notify_new_post_chk').is(':checked')){
            $(notify_new_post).val(1);
        } else {
            $(notify_new_post).val(0);
        }
    })


    let confirmSubscribeModalGeneric = null;
    renderConfig.forEach(function (section) {

        let element = section.type;
        if (element === "profilo-render") {
            return;
        }

        let renderSelector = section.selector;
        //DOWNLOAD NOTIFICATIONS
        if (document.querySelector('#confirmSubscribe'+element)) {

            confirmSubscribeModalGeneric = new bootstrap.Modal(document.querySelector('#confirmSubscribe'+element));
            $(renderSelector).on("click", '.category_notification', function () {
                let item = $(this);


                let confirmSubscribeEl = $("#confirmSubscribe"+element);

                if (item.hasClass("active")) {
                    confirmSubscribeEl.find(".modal-title").text(item.data('title-inactive') + ' '+ item.data('category').title + "?");
                    confirmSubscribeEl.find(".modal-subtitle").text(item.data('subtitle-inactive'));
                } else {
                    confirmSubscribeEl.find(".modal-title").text(item.data('title-active') + ' '+ item.data('category').title + "?");
                    confirmSubscribeEl.find(".modal-subtitle").text(item.data('subtitle-active'));
                }

                confirmSubscribeModalGeneric.show();
                $(".category_notification").removeClass("action-active");
                $(this).addClass("action-active");
            });
        }

        $("#confirmSubscribe"+element+" .btn-data-notification").click(function () {
            let action = $(this).data("action");
            confirmSubscribeModalGeneric.hide();

            if (action === "proceed") {
                subscriptionGeneric(renderSelector, element);
            }

            $(".category_notification").removeClass("action-active");
        })


        function subscriptionGeneric(renderSelector, element) {
            let item = $(renderSelector+" .action-active");
            let type = '';
            let action = item.data("action");

            if (item.hasClass("active")) {
                type = 'disable'
            } else if (item.hasClass("disable")) {
                type = 'active'
            } else {
                type = 'active'
            }

            let catChildrens = null;
            if (item.data('category')) {
                let catChildrens = item.data('category').children;
            }

            $.ajax({
                type: "POST",
                url: '/digitalhub/results/'+element+'/notification',
                data: {id: item.data("id"), trigger: type},
                success: function () {
                    if (item.hasClass('found-in')) {
                        item.removeClass('found-in');
                        item.addClass('active');
                    } else if (item.hasClass('active')) {
                        item.removeClass("active");
                    } else {
                        item.addClass("active");
                    }
                }
            });
            if (action === "hide") {
                item.parent().remove();
                var container = $(".category-notification-profile").length;
                if (container === 0) {
                    let notification_title = $(".profile-notification-title").data("profile-notification");
                    $(".profile-notification-title").text(notification_title);
                }
            }
            if (catChildrens && type === 'active') {
                $.each(catChildrens, function (index, value) {
                    $.ajax({
                        type: "POST",
                        url: '/digitalhub/results/'+element+'/notification',
                        data: {id: value, trigger: 'disable'},
                    });
                });
            }
        }

        //DOWNLOAD FAVOURITE

        $(renderSelector).on("click", '.'+element+'-favorite', function () {
            let item = $(this);
            let type = item.hasClass("active") ? "disable" : "active";
            $.ajax({
                type: "POST",
                url: '/digitalhub/results/'+element+'/favourite',
                data: {id: item.data("id"), trigger: type},
                success: function (data) {

                    item.find("span").text(data.label);
                    $(renderSelector).find("."+element+"-item-" + item.data("id")).remove();

                    if (type === "active") {
                        item.addClass("active");
                    } else {
                        item.removeClass("active");

                    }
                }
            });
            let prefcontainer = $(".preferiti-check-lenght").length;
            if (prefcontainer === 1) {
                let no_preferiti = $(".preferiti-check-title").data("nopreferiti");
                $(".preferiti-check-title").text(no_preferiti);
                $(".ordinator").css('display', 'none');
            }

        });
        //DOWNLOAD SORTING
        $(renderSelector).on("change", '#reorder', function () {
            filters.sort = $(this).val();
            filters.sortby = $(this).children(":selected").data("id");
            quickRender(filters, null, section.selector);
        });

        /****************************
         * TRACKING
         ****************************/
        $(section.selector).on("click", '.track-event', function () {

            let item = $(this);
            let type = item.data("track-type");
            let id = item.data("track-id");

            $.ajax({
                type: "POST",
                url: '/digitalhub/track/store',
                data: {event_type: type, event_value: id},
                success: function (data) {
                }
            });
        });
    });

    let customSearch = ["downloads","videos","photos","posts"];

    customSearch.forEach(function (element) {
        $("#search-render").on("click", '.'+element+'-favorite', function () {
            let item = $(this);
            let type = item.hasClass("active") ? "disable" : "active";
            $.ajax({
                type: "POST",
                url: '/digitalhub/results/'+element+'/favourite',
                data: {id: item.data("id"), trigger: type},
                success: function (data) {

                    item.find("span").text(data.label);
                    $("#search-render").find("."+element+"-item-" + item.data("id")).remove();

                    if (type === "active") {
                        item.addClass("active");
                    } else {
                        item.removeClass("active");
                    }
                    let searchParams = new URLSearchParams(window.location.search);
                    let param = searchParams.get('keyword');

                    if (param) {
                        setTimeout(function () {
                            $("#ricerca").val(param);
                            filters.search = param;
                            // quickRender(filters);
                            // searchStore(param);
                        }, 100);
                    }
                }
            });
            let prefcontainer = $(".preferiti-check-lenght").length;
            if (prefcontainer === 1) {
                let no_preferiti = $(".preferiti-check-title").data("nopreferiti");
                $(".preferiti-check-title").text(no_preferiti);
                $(".ordinator").css('display', 'none');
            }
        });
    })

    /****************************
     * PWA standalone (iOS home screen)
     * Fase 1: tap → fetch in background + progress (nessun vincolo gesto)
     * Fase 2: tap su "Scarica" → navigator.share con gesto fresco + file già in RAM
     ****************************/
    if (window.navigator.standalone) {
        const pwaFiles = {}; // cacheKey → File object già pronto

        function pwaFetchUrl(href) {
            if (href.indexOf('/getfile/') !== -1) return href.replace('/getfile/', '/previewfile/');
            return href; // getvideo, getphoto: fetch diretto
        }

        function pwaFallbackUrl(href) {
            if (href.indexOf('/getfile/') !== -1) return href.replace('/getfile/', '/previewfile/');
            if (href.indexOf('/getvideo/') !== -1) return href.replace('/getvideo/', '/streamvideo/');
            return href;
        }

        const pwaSelector = 'a[href*="/getfile/"], a[href*="/getvideo/"], a[href*="/getphoto/"]';

        $(document).on('click', pwaSelector, async function (e) {
            e.preventDefault();
            const $btn = $(this);
            const href = $btn.attr('href');
            const cacheKey = href;
            const fetchUrl = pwaFetchUrl(href);
            const fallbackUrl = pwaFallbackUrl(href);

            // FASE 2: file già pronto → share immediato con gesto fresco
            if (pwaFiles[cacheKey]) {
                try {
                    await navigator.share({ files: [pwaFiles[cacheKey]] });
                } catch (shareErr) { /* utente ha chiuso */ }
                return;
            }

            // FASE 1: avvia fetch con progress nell'icona
            $btn.data('original-html', $btn.html());
            $btn.html('<span class="spinner-border spinner-border-sm text-secondary" role="status"></span>');
            $btn.css('pointer-events', 'none');

            try {
                const maxBytes = 50 * 1024 * 1024;
                const controller = new AbortController();
                const timeout = setTimeout(function() { controller.abort(); }, 120000);

                const res = await fetch(fetchUrl, { credentials: 'same-origin', signal: controller.signal });
                clearTimeout(timeout);

                const contentLength = parseInt(res.headers.get('content-length') || '0');
                const disposition = res.headers.get('content-disposition') || '';
                const match = disposition.match(/filename[^;=\n]*=["']?([^"';\n]+)/);
                const filename = match ? match[1].trim() : href.split('/').pop();

                if (contentLength > maxBytes) {
                    window.location.href = fallbackUrl;
                    return;
                }

                let blob;
                if (contentLength > 0) {
                    let received = 0;
                    const reader = res.body.getReader();
                    const chunks = [];
                    while (true) {
                        const { done, value } = await reader.read();
                        if (done) break;
                        chunks.push(value);
                        received += value.length;
                        const pct = Math.round((received / contentLength) * 100);
                        $btn.html('<span style="font-size:0.7rem;font-weight:600">' + pct + '%</span>');
                    }
                    blob = new Blob(chunks, { type: res.headers.get('content-type') || 'application/octet-stream' });
                } else {
                    blob = await res.blob();
                }

                const file = new File([blob], filename, { type: blob.type });

                if (navigator.canShare && navigator.canShare({ files: [file] })) {
                    pwaFiles[cacheKey] = file;
                    $btn.html('<span style="font-size:0.7rem;font-weight:600;color:var(--bs-primary)">Scarica</span>');
                    $btn.css('pointer-events', '');
                } else {
                    window.location.href = fallbackUrl;
                }
            } catch (fetchErr) {
                $btn.html($btn.data('original-html'));
                $btn.css('pointer-events', '');
                window.location.href = fallbackUrl;
            }
        });
    }
});
// $.ajax({
//         url: '/digitalhub/results/socialpoststype',
//         success: function (data) {
//             $('#downloads-render').html(data);
//         }
//     });
